import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 100%;
  background: linear-gradient(-45deg, #59abc1, #59c17c);
`;
